import {
  getPatchApiV1ThreeLetterCodeClientAdminsClientPortalItemsIdMutationFetcher,
  getPatchApiV1ThreeLetterCodeClientAdminsClientPortalItemsIdMutationKey,
} from '@fukuri-admins/apis/client/gen/endpoints';
import type { PatchApiV1ThreeLetterCodeClientAdminsClientPortalItemsIdBody } from '@fukuri-admins/apis/client/gen/model';
import { useMutation } from '@fukuri-admins/hooks/common';
import { fileToUrlByBase64 } from '@fukuri-admins/utils/common';
import type { AxiosError } from 'axios';
import { EditPortalFormFieldValues } from '../../logics/schema';

export const usePatchPortal = (
  threeLetterCode: string,
  id: number,
  options?: {
    onSuccess?: () => void;
    onError?: (error: AxiosError<{ errors?: string[] }>) => void;
  }
) => {
  const { trigger: mutate, isMutating } = useMutation(
    getPatchApiV1ThreeLetterCodeClientAdminsClientPortalItemsIdMutationKey(threeLetterCode, id),
    getPatchApiV1ThreeLetterCodeClientAdminsClientPortalItemsIdMutationFetcher(threeLetterCode, id),
    options
  );

  const trigger = async (data: EditPortalFormFieldValues, shouldKeepExistingFile = false) => {
    const body: PatchApiV1ThreeLetterCodeClientAdminsClientPortalItemsIdBody = {
      client_portal_item: {
        title: data.title,
        icon_name: data.icon_name,
        sort_order: data.sort_order,
        item_type: data.item_type,
        url: data.item_type === 'url' ? data.url : null,
      },
    };

    if (data.item_type === 'file') {
      if (data.file) {
        body.client_portal_item.file = await fileToUrlByBase64(data.file);
      } else if (!shouldKeepExistingFile) {
        body.client_portal_item.file = null;
      }
    }

    return mutate(body);
  };

  return {
    trigger,
    isMutating,
  };
};
